import React from 'react';
import {Col} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CountUp from 'react-countup';

const DashboardItem = ({className, color, icon, amount, title}) => {
    return (
        <Col xl={4} sm={6} className={`${className} pb-3 px-3 text-center`}>
            <div className={`icon-circle icon-circle-${color}`}>
                <FontAwesomeIcon icon={icon} className={`fs-2 text-${color}`} />
            </div>
            <h2 className={"mb-1 font-sans=serif h4"}>
                <CountUp start={0} end={amount} duration={2.75} className={"text-700"} separator={","} />
                <span className="fw-normal text-600">{' ' + title}</span>
            </h2>
        </Col>
    )
}
export default DashboardItem